document.addEventListener("DOMContentLoaded", () => {
  // 戻るボタンのセレクタは環境に合わせて増やしてOK
  const backBtns = document.querySelectorAll(".wpcf7-previous");

  if (!backBtns.length) return;

  backBtns.forEach((backBtn) => {
    backBtn.style.removeProperty("display");

    backBtn.addEventListener("click", (e) => {
      e.preventDefault();

      // まずはリファラ（元ページ）を優先
      let to = document.referrer;

      // referrerが取れない/外部/空の場合の保険（必要なら任意のURLに変更）
      if (!to) {
        to = "/"; // 例：トップへ
      }

      // 既に#が付いてても付け替える
      to = to.split("#")[0] + "#form";

      window.location.href = to;
    });
  });
});
